const $inject = ['$state', 'userProfileService', 'userDebtorService', 'SCT_CONFIG'];
let uiRouterBugHack = true;

const sctUserPermissionsService = ($state, userProfileService, userDebtorService, SCT_CONFIG) => {
  const service = {
    permissions: {
      userLevel: null
    },
    checkPermissions,
    isRegistered
  };

  function checkPermissions(state, toParams) {
    if (uiRouterBugHack) {
      uiRouterBugHack = false;

      userProfileService.getAny().then(profileResponse => {
        if (profileResponse.Role === 'DebtorAdmin') {
          userDebtorService.getAny(profileResponse.DebtorIdentifier).then(() => {
            service.permissions.userLevel = SCT_CONFIG.roles[profileResponse.Role];
            uiRouterBugHack = true;
            $state.go(state, toParams);
          });
        } else {
          service.permissions.userLevel = SCT_CONFIG.roles[profileResponse.Role];
          uiRouterBugHack = true;
          $state.go(state, toParams);
        }
      })
    }
  }

  function isRegistered() {
    return userProfileService.profile &&
      userProfileService.profile.Registered;
  }

  return service;
};

sctUserPermissionsService.$inject = $inject;

export default sctUserPermissionsService;


// WEBPACK FOOTER //
// ./src/services/sctUserPermissionsService.js